import React from "react";
import '../../MatchCard.scss'

const StatusGame = ({status,dateMatch,state,firstTime,secondTime,firstExtraTime,
    secondExtraTime,penales,halfTime,restExtraTime,restTime,hs})=>{
      const UperCaseFirstLetter = (str)=>{
        const newWord = str.charAt(0).toUpperCase() + str.slice(1);
        return newWord

      }
      
    const statusGame = ()=>{
        if(status?.scheduleStatus === 'SCHEDULED'){
            return (
            <>
            <div className="contenedorAlter" >
            <p className="titleAlterSize" > {UperCaseFirstLetter(dateMatch.day)}, {dateMatch.date} | {dateMatch.hour} {hs}</p>
          </div>
            </>
            )
        }
        if(status.scheduleStatus === 'COMPLETED'){
            return '' }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === '1H'){
            return (<div className="contenedorAlter border" >
                <p className="titleAlterSize" >{firstTime}</p>
              </div>)
            }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod  === '2H'){
            return (<div className="contenedorAlter border" >
                    <p className="titleAlterSize" >{secondTime}</p>
                  </div>)
                }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === '1ET'){
                    return (<div className="contenedorAlter border" >
                            <p className="titleAlterSize" >{firstExtraTime}</p>
                          </div>)
                        }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === '2ET'){
                            return (<div className="contenedorAlter border" >
                                    <p className="titleAlterSize" >{secondExtraTime}</p>
                                  </div>)
                                }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === 'PSO'){
                                    return (<div className="contenedorAlter border" >
                                            <p className="titleAlterSize" >{penales}</p>
                                          </div>)
                                        }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === 'HT'){
                                          return (<div className="contenedorAlter border" >
                                                  <p className="titleAlterSize" >{halfTime}</p>
                                                </div>)
                                              }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === 'I105'){
                                                return (<div className="contenedorAlter border" >
                                                        <p className="titleAlterSize" >{restExtraTime}</p>
                                                      </div>)
                                                    }
        if(status.scheduleStatus === 'IN_PROGRESS' && state.currentPeriod === 'I90'){
                                                        return (<div className="contenedorAlter border" >
                                                                <p className="titleAlterSize" >{restTime}</p>
                                                              </div>)
                                                            }
            }



    return (
    <>
    {statusGame()}
    </>
        
    )
}

export default StatusGame